import React from 'react'

import { Navigate, Route, Routes } from 'react-router-dom'

import { ErrorBoundary, ErrorScreen } from '../../components'
import { ChallengesProvider } from '../../context/ChallengesContext'
import { AppShell } from '../_components/app-shell'
import { REDESIGN_INITIAL_CHALLENGE } from '../constants/challenge'
import Dashboard from '../pages/Dasboard/Dashboard'
import LearningPathPage from '../pages/LearningPath/LearningPathPage'
import RoutinePage from '../pages/Routine/RoutinePage'
import { RedesignThemeProvider } from '../theme'

const StudentRedesignPreview = () => (
  <ErrorBoundary fallback={<ErrorScreen />}>
    <RedesignThemeProvider>
      <ChallengesProvider initialState={REDESIGN_INITIAL_CHALLENGE}>
        <AppShell>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/redesign/dashboard" element={<Dashboard />} />
            <Route path="/rutina" element={<RoutinePage />} />
            <Route path="/redesign/rutina" element={<RoutinePage />} />
            <Route path="/ruta-formacion" element={<LearningPathPage />} />
            <Route
              path="/redesign/ruta-formacion"
              element={<LearningPathPage />}
            />
            <Route
              path="/redesign/*"
              element={<Navigate to="/redesign/dashboard" replace />}
            />
          </Routes>
        </AppShell>
      </ChallengesProvider>
    </RedesignThemeProvider>
  </ErrorBoundary>
)

export default StudentRedesignPreview
